export default __webpack_public_path__ + "static/media/m2_slider1.431d0740.png";